import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  Transaction,
  TransactionFirebaseService,
  TransactionCategory,
} from 'app/shared';

@Component({
    selector: 'app-transaction-list',
    templateUrl: './transaction-list.component.html',
    styleUrls: ['./transaction-list.component.scss'],
    standalone: false
})
export class TransactionListComponent implements OnChanges {
  // Send back the elements to the parent (details) (comming from transaction)
  @Output() alterTransaction = new EventEmitter<Transaction>();
  @Output() deleteTransaction = new EventEmitter<Transaction>();

  @Input() linkedDate: Date;
  @Input() transactionList: Array<Transaction>;

  public transactionCategoryList: Array<TransactionCategory>;

  constructor(private transactionFirebaseService: TransactionFirebaseService) {}

  /**
   * Watch the date changes and compute again the method accordingly
   *
   * @param changes The linked date
   */
  async ngOnChanges(changes: SimpleChanges) {
    if (
      changes.linkedDate?.isFirstChange() ||
      changes.linkedDate?.previousValue !== changes.linkedDate?.currentValue ||
      changes.transactionList?.previousValue !==
        changes.transactionList?.currentValue
    ) {
      this.populateTransactionCategoryList();
    }
  }

  public onDeleteTransactionEmitted($event: Transaction) {}
  public onAlterTransactionEmitted($event: Transaction) {
    throw new Error('Method not implemented.');
  }

  private populateTransactionCategoryList = async () => {
    // Call transaction service to update transactionCategory data
    this.transactionCategoryList =
      await this.transactionFirebaseService.computeCategoriesFromTransactionList(
        this.transactionList
      );
  };
}
